import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)


export default {
    namespaced:true,
    state: {
  
      users:null,
      token: null,
      idTrabajador : null,
    },
    getters: {
        Users(state){
            return state.users
        },

        Tokens(state){
            return state.token
        },

        IdTrabajador(state){
          return state.idTrabajador
        },

    
    },
    mutations: {
      llenarUser(state,data){
        state.users = data
      },
  
      llenarToken(state,data){
        state.token = data
      },

      llenarIdTrabajador(state,data){
        state.idTrabajador = data
      },

    
    },

    
    actions: {
      async login({ commit }, user) {
        try {
          const response = await axios.post("Autentication/LoginBI", user)
          const data = response.data || {}

          if (!data.token) {
            throw new Error(data.mensaje || "Las credenciales no son válidas")
          }

          localStorage.setItem("access_token", data.token)
          localStorage.setItem("userId", data.userId || "")
          localStorage.setItem("idTrabajdor", data.idTrabajdor || "")
          localStorage.setItem("idSolxPostulante", data.idSolxPostulante || "")
          localStorage.setItem("idPerfil", data.idPerfil || "")
          localStorage.setItem("idContacto", data.idContacto || "")

          commit("llenarUser", data.userId)
          commit("llenarToken", data.token)
          commit("llenarIdTrabajador", data.idTrabajdor)
          return data
        } catch (error) {
          const backendMessage = error.response && error.response.data && error.response.data.mensaje
          const message = backendMessage || error.message || "No pudimos conectar con el servidor"
          throw message
        }
      },
    },
    modules: {
    }
  }
  